import { PublicLayout } from '../../components/layout/PublicLayout';
import './legal.css';

export function TermsPage() {
  return (
    <PublicLayout>
      <div className="legal-page">
        <div className="legal-prose">
          <span className="legal-chip">Terms of use</span>
          <h1>Terms of use</h1>
          <p>
            <strong>Draft for legal review.</strong> These terms govern your use of the Sarnia Builder website-builder
            service operated by Sarnia Digital, based in Guernsey.
          </p>
          <h2>1. The service</h2>
          <p>
            Sarnia Builder lets you create and edit a website in your browser, share a clearly marked preview link to get
            feedback, and export the finished site as a ZIP file to host wherever you like. We do not host live customer
            websites as part of the free service, and preview links may be changed or removed at any time. You are
            responsible for the content you create, share and export, and for keeping your account credentials secure.
          </p>
          <h2>2. Acceptable use</h2>
          <p>
            You may not create, share or export unlawful, abusive, fraudulent or infringing content. We may suspend a
            site, preview or account if we reasonably believe it violates these terms or applicable law. A report-abuse
            link on every shared preview lets visitors notify us.
          </p>
          <h2>3. Subscription and billing</h2>
          <p>
            Building, previewing and exporting are free. Optional paid plans (see the <a href="/pricing">Pricing</a> page)
            add hands-on help getting your site live on your own domain and ongoing maintenance. Paid plans are billed
            monthly. You can cancel at any time; cancelling ends the extra help at the end of the current billing period.
            Your sites and drafts stay in your account unless you delete it, and anything you have exported remains yours.
          </p>
          <h2>4. Data and privacy</h2>
          <p>
            We process personal data as described in our <a href="/privacy">Privacy Policy</a>. Shared previews do not set
            cookies from our platform, although a contact form on your site may collect information that is sent to you.
          </p>
          <h2>5. Liability</h2>
          <p>
            The service is provided “as is” without warranties to the extent permitted by law. We are not liable for
            indirect or consequential loss arising from your use of the service or the content of your site.
          </p>
          <h2>6. Changes</h2>
          <p>We may update these terms from time to time. Material changes will be communicated by email or in-app notice.</p>
          <p>Last updated: 4 October 2026.</p>
        </div>
      </div>
    </PublicLayout>
  );
}
